import { NlpModel } from '@feedyou/schema'
import { Storage, StorageType } from '../types'

export const extractNlpStorages = (model: NlpModel | undefined): Storage[] => {
  if (!model?.entities) {
    return []
  }

  return model.entities?.map(entity => {
    return {
      nlpId: model.id,
      name: entity.id.toLowerCase(),
      storageType: ['NLP entity' as StorageType]
    }
  })
}
